import { apiSlice } from "./apiSlice";
import {
  createMultipleWarehouses,
  createWarehouses,
  getBottomDifotMetrics,
  getBottomLeadMetrics,
  getDownloadedWarehouses,
  getMetricsCriteria,
  getSupplierMetrics,
  getSuppliers as getSuppliersReducer,
  getSuppliersFields,
  getTopDifotMetrics,
  getTopLeadMetrics,
  getTopSuppliersSpend,
  getWarehouseBasedWareCosting,
  getWarehouseFields,
  getWarehouses,
  getWarehouseType,
  setSuppliersSelection,
  setWarehouse,
  setWarehousesSelection,
  updateMultipleWarehouses,
  updateWarehouse,
} from "../slice/supplierSlice";

export const purchaseApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    createMetricsCriteria: builder.mutation({
      query: data => ({ url: "/api_supplier/metrics_criteria/", method: "post", body: data }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getMetricsCriteria(result.data.data)))
          .catch(error => {});
      },
    }),
    createMultipleWarehouses: builder.mutation({
      query: data => ({
        url: "/api_supplier/warehouse/create_multiple_warehouses/",
        method: "post",
        body: data,
      }),
      invalidatesTags: (result, error) => error ? [] : ["WarehouseList", "WarehouseSelection", "WarehouseDetail", "FacilityCodeOptions"],
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(createMultipleWarehouses(result.data.data)))
          .catch(error => {});
      },
    }),
    createSuppliers: builder.mutation({
      invalidatesTags: (result, error) => error ? [] : ["SupplierList", "SupplierSelection", "SupplierCodeOptions"],
      query: data => ({ url: "/api_supplier/supplier/", method: "post", body: data }),
    }),
    createWarehouse: builder.mutation({
      query: data => ({
        url: "/api_supplier/warehouse/",
        method: "post",
        body: data,
      }),
      invalidatesTags: (result, error) => error ? [] : ["WarehouseList", "WarehouseSelection", "WarehouseDetail", "FacilityCodeOptions"],
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(createWarehouses(result.data))).catch(error => {});
      },
    }),
    getDifotMetrics: builder.query({
      query: params => `/api_supplier/difot_metrics/?${params}`,
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => {
            dispatch(getTopSuppliersSpend(result.data.data.top_spend));
            dispatch(getTopDifotMetrics(result.data.data.top_difot));
            dispatch(getBottomDifotMetrics(result.data.data.bottom_difot));
          })
          .catch(error => {});
      },
    }),
    getDownloadedWarehouses: builder.query({
      query: params =>
        params
          ? `/api_supplier/warehouse/download_records/?${params}`
          : "/api_supplier/warehouse/download_records/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getDownloadedWarehouses(result.data.data)))
          .catch(error => {});
      },
    }),
    getLeadTimeMetrics: builder.query({
      query: params => `/api_supplier/lead_time_metrics/?${params}`,
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => {
            dispatch(getTopLeadMetrics(result.data.data.top_leads));
            dispatch(getBottomLeadMetrics(result.data.data.bottom_leads));
          })
          .catch(error => {});
      },
    }),
    getMetricsCriteria: builder.query({
      query: () => "/api_supplier/metrics_criteria/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getMetricsCriteria(result.data.data)))
          .catch(error => {});
      },
    }),
    getSupplierMetrics: builder.query({
      query: params => `/api_supplier/supplier_metrics/?${params}`,
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getSupplierMetrics(result.data.data)))
          .catch(error => {});
      },
    }),
    getSuppliers: builder.query({
      providesTags: ["SupplierList"],
      query: (params = null) =>
        params ? `/api_supplier/supplier/?${params}` : "/api_supplier/supplier/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getSuppliersReducer(result.data)))
          .catch(error => {});
      },
    }),
    getSupplierCodeOptions: builder.query({
      providesTags: ["SupplierCodeOptions"],
      query: params => ({ url: "/api_supplier/supplier/code_options/", params }),
    }),
    getSupplierById: builder.query({
      providesTags: (result, error, id) => [{ type: "SupplierDetail", id: Number(id) }],
      query: id => ({
        url: `/api_supplier/supplier/${id}/`,
      }),
    }),
    getSuppliersFields: builder.query({
      query: () => "/api_supplier/suppliers_fields/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getSuppliersFields(result.data))).catch(error => {});
      },
    }),
    getSuppliersSelection: builder.query({
      providesTags: ["SupplierSelection"],
      query: params =>
        params
          ? `/api_supplier/supplier/?mode=selection&${params}`
          : `/api_supplier/supplier/?mode=selection`,
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(setSuppliersSelection(result.data)))
          .catch(error => {});
      },
    }),
    getWarehouse: builder.query({
      query: params => (params ? `/api_supplier/warehouse/?${params}` : "/api_supplier/warehouse/"),
      providesTags: ["WarehouseList"],
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getWarehouses(result.data))).catch(error => {});
      },
    }),
    getFacilityCodeOptions: builder.query({
      providesTags: ["FacilityCodeOptions"],
      query: params => ({ url: "/api_supplier/warehouse/code_options/", params }),
    }),
    getWarehouseById: builder.query({
      providesTags: (result, error, id) => [{ type: "WarehouseDetail", id: Number(id) }],
      query: id => ({
        url: `/api_supplier/warehouse/${id}/`,
      }),
    }),
    getWarehouseSelection: builder.query({
      query: arg => ({
        url: "/api_supplier/warehouse/",
        params: { mode: "selection", ...(arg?.params || {}) },
      }),
      providesTags: ["WarehouseSelection"],
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(setWarehousesSelection(result.data)))
          .catch(error => {});
      },
    }),
    getWarehouseBasedWareCosting: builder.query({
      query: (params = null) => `/api_supplier/get_warehouses_warehouse_costing/`,
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getWarehouseBasedWareCosting(result.data.data)))
          .catch(error => {});
      },
    }),
    getWarehouseDetail: builder.query({
      providesTags: (result, error, id) => [{ type: "WarehouseDetail", id: Number(id) }],
      query: params => `/api_supplier/warehouse/${params}/`,
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(setWarehouse(result.data))).catch(error => {});
      },
    }),
    getWarehouseFields: builder.query({
      query: () => "/api_supplier/warehouse_fields/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getWarehouseFields(result.data))).catch(error => {});
      },
    }),
    getWarehouseType: builder.query({
      query: () => "/api_supplier/warehouse_type/",
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(getWarehouseType(result.data))).catch(error => {});
      },
    }),
    updateMetricsCriteria: builder.mutation({
      query: ({ id, data }) => ({
        url: `/api_supplier/metrics_criteria/${id}/`,
        method: "PATCH",
        body: data,
      }),
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(getMetricsCriteria(result.data.data)))
          .catch(error => {});
      },
    }),
    updateMultipleWarehouses: builder.mutation({
      query: data => ({
        url: "/api_supplier/warehouse/update_downloaded_warehouses/",
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error) => error ? [] : ["WarehouseList", "WarehouseSelection", "WarehouseDetail", "FacilityCodeOptions"],
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(updateMultipleWarehouses(result.data.data)))
          .catch(error => {});
      },
    }),
    updateSuppliers: builder.mutation({
      invalidatesTags: (result, error, { id }) => error ? [] : ["SupplierList", "SupplierSelection", "SupplierCodeOptions", { type: "SupplierDetail", id: Number(id) }, "WarehouseList", "WarehouseSelection", "WarehouseDetail"],
      query: ({ id, data }) => ({
        url: `/api_supplier/supplier/${id}/`,
        method: "PATCH",
        body: data,
      }),
    }),
    updateWarehouse: builder.mutation({
      query: ({ id, data }) => ({
        url: `/api_supplier/warehouse/${id}/`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error) => error ? [] : ["WarehouseList", "WarehouseSelection", "WarehouseDetail", "FacilityCodeOptions"],
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled
          .then(result => dispatch(updateWarehouse(result.data.data)))
          .catch(error => {});
      },
    }),
    updateWarehouseV2: builder.mutation({
      query: ({ id, data }) => ({
        url: `/api_supplier/warehouse/${id}/`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error) => error ? [] : ["WarehouseList", "WarehouseSelection", "WarehouseDetail", "FacilityCodeOptions"],
      onQueryStarted: (_, { dispatch, queryFulfilled }) => {
        queryFulfilled.then(result => dispatch(updateWarehouse(result.data))).catch(error => {});
      },
    }),
  }),
});

export const {
  useCreateMetricsCriteriaMutation,
  useCreateMultipleWarehousesMutation,
  useCreateSuppliersMutation,
  useCreateWarehouseMutation,
  useGetDifotMetricsQuery,
  useGetLeadTimeMetricsQuery,
  useGetMetricsCriteriaQuery,
  useGetSupplierMetricsQuery,
  useGetSuppliersFieldsQuery,
  useGetSupplierByIdQuery,
  useGetSupplierCodeOptionsQuery,
  useLazyGetSupplierCodeOptionsQuery,
  useGetSuppliersQuery,
  useGetSuppliersSelectionQuery,
  useLazyGetSuppliersSelectionQuery,
  useGetWarehouseBasedWareCostingQuery,
  useGetWarehouseDetailQuery,
  useGetWarehouseFieldsQuery,
  useGetWarehouseQuery,
  useGetFacilityCodeOptionsQuery,
  useLazyGetFacilityCodeOptionsQuery,
  useGetWarehouseByIdQuery,
  useGetWarehouseSelectionQuery,
  useGetWarehouseTypeQuery,
  useLazyGetDownloadedWarehousesQuery,
  useLazyGetSuppliersQuery,
  useLazyGetWarehouseDetailQuery,
  useLazyGetWarehouseQuery,
  useUpdateMetricsCriteriaMutation,
  useUpdateMultipleWarehousesMutation,
  useUpdateSuppliersMutation,
  useUpdateWarehouseMutation,
  useUpdateWarehouseV2Mutation,
} = purchaseApiSlice;
